import PackagingController from './PackagingController';
import PackingDaisyService from './services/PackingDaisyService';
import SubsetController from './SubsetController';
import CommentModalController from './CommentModalController';
import FinishPackingSlipModalController from './FinishPackingSlipModalController';
import PackingSaveModalController from './PackingSaveModalController';
import NumberFormatService from './services/NumberFormatService';

const module = angular.module('myApp.packaging', []);
module.service('packingDaisyService', PackingDaisyService);
module.service('numberFormatService', NumberFormatService);
module.controller('PackagingController', PackagingController);
module.controller('SubsetController', SubsetController);
module.controller('CommentModalController', CommentModalController);
module.controller('FinishPackingSlipModalController', FinishPackingSlipModalController);
module.controller('PackingSaveModalController', PackingSaveModalController);
module.filter('daisyNumber', function(){
    return function(input) {
        let numberString = input.toString();
        numberString = numberString.replace('.', ',');

        return numberString;
    };
});